import { Modal, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolLinksData } from "@virtual-brain-lib/types";

import { LinkRow } from "./LinkRow";

interface ToolCardAllLinksModalProps {
	readonly isOpen: boolean;
	readonly close: () => void;
	readonly links: MessageToolLinksData["links"];
	readonly contentReferenceOffset?: number;
}

export function ToolCardAllLinksModal({
	isOpen,
	close,
	links,
	contentReferenceOffset,
}: ToolCardAllLinksModalProps) {
	const offset = contentReferenceOffset ?? 0;
	const reviewedLinks = offset > 0 ? links.slice(0, offset) : [];
	const availableLinks = offset > 0 ? links.slice(offset) : links;

	return (
		<Modal
			close={close}
			icon="globe"
			isOpen={isOpen}
			size="lg"
			classNames={{
				body: "p-0 max-h-[80vh]",
			}}
			footer={{
				secondaryButton: {
					hidden: true,
				},
			}}
			title={`All links (${links.length})`}
		>
			<div className="overflow-y-auto px-4 pt-4">
				{offset === 0 || reviewedLinks.length === 0 ? (
					<div className="flex flex-col">
						{links.map((link) => (
							<LinkRow key={link.id} link={link} />
						))}
					</div>
				) : (
					<div className="mb-4 flex flex-col gap-6">
						{reviewedLinks.length > 0 && (
							<div className="flex flex-col gap-2">
								<div className="flex flex-col gap-0.5">
									<Span isBlock className="font-semibold" variant="body-sm">
										Reviewed ({reviewedLinks.length})
									</Span>
									<Span isBlock color="defaultLight" variant="body-xs">
										Taken into account when generating this answer.
									</Span>
								</div>
								<div className="border-subtle h-60 overflow-y-auto rounded-lg border bg-background p-2">
									{reviewedLinks.map((link) => (
										<LinkRow key={link.id} link={link} />
									))}
								</div>
							</div>
						)}

						{availableLinks.length > 0 && (
							<div className="flex flex-col gap-2">
								<div className="flex flex-col gap-0.5">
									<Span isBlock className="font-semibold" variant="body-sm">
										Available for deeper analysis ({availableLinks.length})
									</Span>
									<Span isBlock color="defaultLight" variant="body-xs">
										Click 'Dig Deeper' in your deliverable to take these into
										account.
									</Span>
								</div>
								<div className="border-subtle h-60 overflow-y-auto rounded-lg border bg-secondary/20 p-2">
									{availableLinks.map((link) => (
										<LinkRow key={link.id} link={link} />
									))}
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</Modal>
	);
}
